import { httpClient } from "@services/api/httpClient";

export interface IVerifyEmailResponse {
    success: boolean;
    data?: {
        verified: boolean;
        token?: string;
        expiresAt?: string | number;
    };
}

const verifyEmail = async (email: string, code: string): Promise<IVerifyEmailResponse> => {
    const response = await httpClient.post<IVerifyEmailResponse>("/auth/verify-email", {
        email,
        code,
    });

    return response.data;
};

export default verifyEmail;
